// @flow
import React from 'react';

export const styles = (theme: Object) => ({
  drawerPaper: {
    width: window.innerWidth < 500 ? window.innerWidth : 270,
    marginTop: 67,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      width: '0 !important',
    },
    backgroundColor: theme.palette.secondary[theme.palette.type],
  },
  listItemText: {
    paddingRight: 0,
  },
  expandIcon: {
    minWidth: 0,
    '& i': {
      marginLeft: 0,
    },
  },
});

export const EmptyIcon = () => <div style={{ width: 24, marginRight: 16 }} />;
